import PortalIdParser from 'PortalIdParser';
import { Avatar } from 'avatar-components/Avatar';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContactAvatarCHIRP = ({
  contact,
  size = 'sm'
}) => {
  // TODO: CHIRP Contacts don't have a portalId, is it ok to just use the default portalId?
  const portalId = PortalIdParser.get();
  const email = contact === null || contact === void 0 ? void 0 : contact.email;
  return /*#__PURE__*/_jsx(Avatar, {
    email: email,
    size: size,
    portalId: portalId
  });
};